module.exports = __webpack_public_path__ + "static/media/ringers-logo-charcoal.745460a9.svg";